import * as types from './types';

const initialState = {
  loading: false,
  employer: {},
  employerProfiles: [],
  currentEmployerProfile: {},
  locations: [],
  error: false,
  subscription: {},
  connectors: [],
  fetchCompleted: null,
  hiringHeroMetrics: [],
  systemNotifications: undefined,
};

const employerReducer = (state = initialState, { type, payload, errors }) => {
  switch (type) {
    case types.EMPLOYER_LOAD_START:
      return {
        ...state,
        loading: true,
        validationErrors: [],
        fetchCompleted: false,
      };
    case types.EMPLOYER_SUBSCRIPTION_LOAD_SUCCESS:
      return {
        ...state,
        subscription: payload[0],
      };

    case types.EMPLOYER_LOAD_SUCCESS:
      return {
        ...state,
        employer: payload,
        loading: false,
        validationErrors: [],
        fetchCompleted: true,
      };
    case types.EMPLOYER_VALIDATION_ERROR:
      return {
        ...state,
        validationErrors: errors,
        loading: false,
      };
    case types.EMPLOYER_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: errors,
        fetchCompleted: true,
      };
    case types.CURRENT_EMPLOYER_PROFILE_LOAD_SUCCESS:
      return {
        ...state,
        currentEmployerProfile: payload,
        fetchCompleted: true,
      };
    case types.EMPLOYER_PROFILE_LOAD_SUCCESS:
      return {
        ...state,
        employerProfiles: payload,
        currentEmployerProfile: payload[0],
        fetchCompleted: true,
      };
    case types.ADD_NEW_LOCATION:
      return {
        ...state,
        locations: [...state.locations, payload],
      };
    case types.LOCATIONS_LOAD_SUCCESS:
      return {
        ...state,
        locations: payload,
      };
    case types.DELETE_LOCATION_SUCCESS:
      const locations = state.locations.filter((location) => location.id !== payload.id);
      return {
        ...state,
        locations,
      };
    case types.CONNECTORS_LOAD_SUCCESS:
      return {
        ...state,
        connectors: payload,
      };
    case types.HIRING_HERO_METRICS_LOAD_SUCCESS:
      return {
        ...state,
        hiringHeroMetrics: payload,
      };
    case types.EMPLOYER_PROFILE_NOTIFICATIONS_LOAD_SUCCESS:
      return {
        ...state,
        systemNotifications: payload,
      };
    case types.EMPLOYER_PROFILE_NOTIFICATIONS_LOAD_FAILURE:
      return {
        ...state,
        systemNotifications: null,
      };

    default:
      return state;
  }
};

export default employerReducer;
